/** ========================================================================
 * Mixin usado nas páginas internas de pontos do hotel
 * ========================================================================= */
import { parseISO } from 'date-fns'
import { mapActions } from 'vuex'
import { formatDate, getWeekDaysFromInterval } from '@/helpers/date'
import { capitalizeString } from '@/helpers/string'

export default {
  props: {
    /** Dados do hotel */
    hotel: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      /** ponto de partida do breadcrumb */
      rootPath: {
        label: 'Home',
        url: '/',
        isSpa: true /** se deve ser um link para o site novo ou antigo */
      },
      /** Caminho de pão */
      breadcrumb: [
        {
          label: 'Letsbook',
          url: '',
          isSpa: false
        },
        {
          label: 'Hotéis',
          url: '/hoteis',
          isSpa: true /** se deve ser um link para o site novo ou antigo */
        },
        {
          label: capitalizeString(this.hotel.nome),
          url: `/hoteis/editar/${this.hotel.codigo}`,
          isSpa: true /** se deve ser um link para o site novo ou antigo */
        },
        {
          label: 'Atualização de pontos',
          url: `/hotel/pontos/${this.hotel.codigo}`,
          isSpa: true /** se deve ser um link para o site novo ou antigo */
        }
      ],

      showConfirmationModal: false /** Modal de Confirmação */,
      pageTitle: 'Atualização de pontos'
    }
  },

  methods: {
    confirmRatesUpdate() {
      this.showConfirmationModal = true
    },

    /** Salva os editados */
    saveRatesUpdate() {
      this.showLoaderModal = true

      const finalObj = this.applyApiFormat(this.formatRoomRates)

      /** Salva os valores de pontos por períodos */
      this.$calendar
        .updatePointsPeriods(finalObj)
        .then(() => {
          this.resetForm()
          this.$bus.$emit('show-alert-chip', {
            message:
              'Estamos salvando suas alterações, avisaremos assim que terminar'
          })
          this.showAlertConfirmation = true
          this.showLoaderModal = false
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error.messages
          })
          this.showLoaderModal = false
        })
    },
    /**
     * Formata para o novo padrão para o payload do post da API
     * @param {Object} apiObj
     * @returns {Object} Objeto padronizado
     * @see https://guest-dev.letsbook.com.br/docs/lb-api-admin/#api-Calendario-PostCalendarioPeriodo
     * TODO Refatorar e separar em uma função que retorna o valor para cada item manipulado
     */
    applyApiFormat(apiObj) {
      const formatted = {
        codigoHotel: this.hotel.codigo,
        pontosPeriodo: []
      }

      /** Tarifas */
      apiObj.tarifas.forEach((rate) => {
        /** Itera por cada quarto */
        rate.quartos.forEach((room) => {
          /** Array com as datas dos dias selecionados do período */
          const days = getWeekDaysFromInterval(
            {
              start: parseISO(rate.dataInicial),
              end: parseISO(rate.dataFinal)
            },
            room.diasSemana.map((day) => day - 1)
          )

          /** Para cada dia cria um objeto */
          days.forEach((day) => {
            const dayRateObj = {
              data: formatDate(day, 'yyyy-MM-dd'),
              codigoQuarto: room.codigo,
              codigoTarifa: room.codigoTarifa,
              tipoAtualizacaoValor: room.tipoAtualizacaoValor,
              pontosPax: room.valores,
              quantidadePontos: room.quantidadePontos
            }

            formatted.pontosPeriodo.push(dayRateObj)
          })
        })
      })

      return formatted
    },

    /**
     * Monta o objeto das regras do quarto
     * @param {Object} objRoom - objeto com as configurações selecionadas
     *
     * @returns {Array} - Array com os objetos das regras
     */
    buildRoomRulesObj(objRoom) {
      return Object.entries(objRoom).reduce((acc, curr) => {
        /** verifica se é um pax */
        if (curr[0].search(/^(pax|criancas)/gim) > -1) {
          let obj = {}
          if (curr[1] !== null && curr[1] !== '') {
            obj = {
              tipoPax:
                curr[0].match(/[^\d]{1,}/gim)[0] === 'pax'
                  ? 10
                  : 8 /** 10-Adulto, 8-Criança */,
              quantidadePax: +curr[0].match(/(\d){1,}/gim)[0],
              quantidadePontos:
                typeof +curr[1] === 'number'
                  ? parseFloat(curr[1])
                  : null /** Se é um número faz o parse senão seta como null */
            }
          }
          acc.push(obj)
        }
        return acc
      }, [])
    },

    /** Reseta os formulários para o estado inicial */
    resetForm() {
      this.setResetForm()
    },
    ...mapActions('hotel', ['setResetForm'])
  }
}
